import { outdoor_registry } from "./outdoor_registry";

export const generate_outdoor_meters_demo = () => {
    return outdoor_registry.map((meter) => ({
        meter_id: meter.meter_id,
        meter_name: meter.meter_name,
    }));
};